import styled from 'styled-components';
import { theme } from '../../theme/theme';
import { Breakpoints } from '../CSSHelper';

export const TextHighlight = styled.span<{ $color?: keyof typeof theme }>`
	color: ${({ $color, theme }) => ($color ? theme[$color] : 'inherit')};
`;

export const Text = styled.p<{
	$color?: keyof typeof theme;
	$size?: string;
	$weight?: string;
	$font?: keyof typeof theme;
	$colorHover?: keyof typeof theme;
	$medSize?: string;
	$tabletSize?: string;
	$mobileSize?: string;
}>`
	color: ${(props) => (props.$color ? props.theme[props.$color] : props.theme.text_title_main)};
	font-size: ${(props) => (props.$size ? props.$size : 'initial')};
	font-weight: ${(props) => (props.$weight ? props.$weight : '600')};
	font-family: ${(props) => (props.$font ? props.theme[props.$font] : props.theme.FONTS_PRIMARY)};
	${({ $colorHover }) => ($colorHover ? `transition: color 0.2s!important;` : '')}
	line-height: 1.15;

	&:hover {
		${({ $colorHover: colorHover, theme }) => (colorHover ? `color: ${theme[colorHover]};` : '')}
	}
	@media (max-width: 1024px) {
		${(props) => (props.$medSize ? ` font-size: ${props.$medSize};` : '')};
	}
	@media (max-width: ${Breakpoints.TABLET}) {
		${(props) => (props.$tabletSize ? ` font-size: ${props.$tabletSize};` : '')};
	}
	@media (max-width: 525px) {
		${(props) => (props.$mobileSize ? ` font-size: ${props.$mobileSize};` : '')};
	}
`;
